import { spawn } from 'redux-saga/effects';

import poolSaga from './pool/sagas';

export default function* ipSagas() {
	yield spawn(poolSaga);
}
